import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Section,
  SectionItemForm,
  SectionList,
  SectionTitle,
} from '../../../shared/section'
import { InputWithLabel } from '../../../shared/form'
import { ContentArea } from '../../../shared/content'
import { translationsActivity } from '../translations/translationsActivity'

const SignatureNameField: React.FC = () => {
  const intl = useIntl()

  return (
    <ContentArea>
      <Section>
        <SectionTitle>
          <FormattedMessage
            id="activity.sign.form.name.title"
            defaultMessage="Customer name"
          />
        </SectionTitle>
        <SectionList>
          <SectionItemForm>
            <InputWithLabel
              type="text"
              id="name"
              name="name"
              label={
                <FormattedMessage {...translationsActivity.signFormName} />
              }
              placeholder={intl.formatMessage(
                translationsActivity.signFormName
              )}
            />
          </SectionItemForm>
        </SectionList>
      </Section>
    </ContentArea>
  )
}

export { SignatureNameField }
